module.exports = __webpack_public_path__ + "media/images/emblems/Schattenhalb-coat_of_arms-6801b61991a6bf5079fa284e2e45340c.svg";